import { render, staticRenderFns } from "./EmissionPointEdit.vue?vue&type=template&id=535ac291&scoped=true"
import script from "./EmissionPointEdit.vue?vue&type=script&lang=js"
export * from "./EmissionPointEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535ac291",
  null
  
)

export default component.exports